import React, { createRef } from "react";
import { Card, Flex, Heading, Text, Theme } from "@radix-ui/themes";
import { Link } from "../components/Link";
import { useBackgroundMachineSlideshow } from "../hooks/useBackgroundMachineSlideshow";

/**
 * This page is displayed when a new user has signed up but has not
 * yet been granted access to any facilities/jobs.
 *
 * This page does not rely on any router or authentication context, and is
 * fully self-contained with theme included.
 */
export default function PendingAccess() {
  const ref = createRef<HTMLDivElement>();
  useBackgroundMachineSlideshow(ref);

  return (
    <>
      <style>
        {`
          html, body {
            margin: 0
          }
        `}
      </style>
      <Theme appearance="light">
        <Flex
          ref={ref}
          direction="column"
          align="center"
          justify="center"
          style={{
            backgroundImage: "url(https://smart.evueanywhere.com/images/background/pt-vario.webp)",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            transition: "background-image 0.6s ease-in-out",
            height: "100vh",
            width: "100vw",
          }}
        >
          <Card size="4" style={{ width: 400 }}>
            <Heading as="h3" size="6" trim="start" mb="5">
              Welcome to SmartView!
            </Heading>
            <Text as="div" size="2" weight="medium" mb="3">
              Thank you for signing up! We will be granting you access shortly.
            </Text>

            <Text as="div" size="2" weight="medium" mb="3">
              If you have any questions, please contact Larry Erickson or <Link to="/login">logout</Link> and try again later.
            </Text>
          </Card>
        </Flex>
      </Theme>
    </>
  );
}